import withStyles from '@material-ui/core/styles/withStyles';
import AppAvatar from '../../../Avatar/AppAvatar';
import { makeTransitionStyles } from '../../../styles';

const styles = {
  root: {
    ...makeTransitionStyles('transform .5s, visibility .5s ease-in'),
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 5,
    width: '100%',
    height: '100%',
  },
};

export default withStyles(styles)(AppAvatar);
